import * as React from "react";
import { useCallback, useState } from "react";
import { useDebounceFunction as useDebounce } from "hooks";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { DATATEST } from "constants/integration";

interface IHoverProps {
    children: (props: { hover: boolean; left: number }) => React.ReactNode;
    debounce?: number;
    disableTouch?: boolean; // prevent hover on tap events
    className?: string;
}

export const HoverListener = ({ children, debounce = 0, className, disableTouch = true }: IHoverProps) => {
    const [hover, setHover] = useState<boolean>(false);
    const [left, setLeft] = useState<number>(null);
    const [touch, setTouch] = useState<boolean>(false);

    const setHoverDebounced = useDebounce(setHover, debounce);

    const onEnter = useCallback(
        (event) => {
            if (!touch || !disableTouch) {
                setHoverDebounced(true);
                setLeft(window.innerWidth - event.currentTarget.getBoundingClientRect().left);
            }
        },
        [setHoverDebounced, touch, disableTouch]
    );
    const onLeave = useCallback(() => {
        setHoverDebounced(false);
        setTouch(false);
    }, [setHoverDebounced]);
    const onTouch = useCallback(() => {
        if (disableTouch) {
            setTouch(true);
        }
    }, [disableTouch]);

    return (
        <ClickAwayListener onClickAway={onLeave}>
            <div
                data-test={DATATEST.HOVER_LISTENER}
                className={className}
                onMouseLeave={onLeave}
                onMouseEnter={onEnter}
                onMouseOver={onEnter}
                onTouchStart={onTouch}
            >
                {children({ hover, left })}
            </div>
        </ClickAwayListener>
    );
};

export default HoverListener;
